module.exports = __webpack_public_path__ + "img/40_38_036_300.325deaf8.jpg";